import type { TEditableProps } from '@udecode/plate';

export const editorProps: TEditableProps = {
  placeholder: 'Add your comment',
  spellCheck: true,
  readOnly: false,
  autoFocus: true,
};
